import React, { PureComponent, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Icon } from 'antd';
import Ripple from 'containers/backend/common/component/Ripple';
import { PATHS } from 'constants/Define';
import { isEqual } from 'lodash';
import RateCompare from 'models/RateCompare';
import * as Func from '../../../../../helpers/functions';
import Modal from 'containers/backend/common/component/Modal';
import { ListComponent } from 'containers/backend/common/component/Index';

const ListCols = ['rateCodeCompare', 'rateCodePriority', 'note', 'action'];
const ModelFields = Object.getOwnPropertyNames(new RateCompare());
export default class RateCompareList extends PureComponent {
    constructor(props) { 
        super(props);
        this.state = {
            itemRow: {},
            titleItemTable: Func.getTitleTable(ListCols, []),
            modelItem: ModelFields,
            componentTable: {
                action: {
                    width: 80,
                    align: 'center',
                    key: 'action',
                    fixed: 'right',
                    render: (text, record) => this.renderActionComponent(record),
                }
            },
            filters: {},
            rateCompareList: [],
            selectedFields: [],
            headSelectedIndex: 0,
            firstSelectedIndex: 0 
        }
    }

    clearItemSelection() {
      this.setState({ selectedFields: [], headSelectedIndex: 0, firstSelectedIndex: 0 });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.rateCompareList && !isEqual(nextProps.rateCompareList, this.props.rateCompareList)) {
            this.setState({ rateCompareList: nextProps.rateCompareList });
            this.clearItemSelection();
        }
        if(!nextProps.isSort || !isEqual(nextProps.isSort, this.props.isSort)){
          this.clearItemSelection();
        }
    }
  
    renderActionComponent(item) {
        const { t, hotel_id } = this.props;

        const removeItem = () => {
            this.props.deleteRateCompare({
                id: item.id,
                filters: {
                    hotelId: hotel_id,
                    pageSize: 1000
                }
            })
        }

        const onRemove = () => {
            const { confirm } = Modal;
            confirm({
                title: Func.formatValidation(t('validation.statusCode.code.7'), t(`item.rateCompare.title`)),
                content: `${item.rateCodeCompare} - ${item.rateCodePriority}`,
                okText: t(`action.remove`),
                cancelText: t(`action.cancel`),
                onOk: removeItem,
            });
        };
        return (
            <Fragment>
                <Link to={
                    Func.getPathWithParams(PATHS.RATE_COMPATE.DETAIL.path, {
                        hotel_id: hotel_id,
                        id: item.id,
                    })}
                    className={`mr-2 colorPrimary`}
                >
                    <Ripple><Icon type="form" className="fs20" /></Ripple>
                </Link>
                <Ripple onClick={onRemove}><Icon type="delete" className="fs20 colorPrimary" /></Ripple>
            </Fragment>
        )
    }

    render() {
        const { loading, moveRow, onChange } = this.props;
        const { titleItemTable, modelItem, componentTable, rateCompareList, selectedFields, headSelectedIndex } = this.state;
        return (
            <ListComponent
                tableKey="room-type-list"
                rowClassName={(record, index) => selectedFields.findIndex(item => item.id === record.id) > -1 && 'table-row-light'}
                classChildren="p-0" classParent="m-0"
                rowKey={(record, k) => record.id ? record.id : k}
                loading={{ spinning: loading, size: 'large' }}
                dataSource={Func.getDataSource(rateCompareList || [], modelItem)}
                columns={Func.columnsTable({
                    titleTable: titleItemTable,
                    component: componentTable,
                    itemName: 'rateCompare'
                })}
                onChange={onChange}
                componentTableList={{}}
                onRow={(record, index) => ({
                    record,
                    index,
                    moveRow,
                    selectedFields,
                    headSelectedIndex
                })}
            />
        );
    }
}